import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { provideState } from '@ngrx/store';
import { TranslateModule } from '@ngx-translate/core';

import { ConfirmationModalComponent } from './components/confirmation/confirmation-modal.component';
import { ConfirmationDialogService } from './components/confirmation/confirmation-modal.service';
import { GenericModalComponent } from './components/generic-modal/generic-modal.component';
import { DialogComponent } from './dialog.component';
import { DialogService } from './dialog.service';
import { ModalReducer } from './store/modal.reducer';

import { FocusTrapDirective } from '@shared/accessibility/directives/focus-trap.direcetive';

@NgModule({
    declarations: [
        ConfirmationModalComponent,
        DialogComponent,
        GenericModalComponent,
    ],
    imports: [
        CommonModule,
        FocusTrapDirective,
        TranslateModule.forChild(),
        MdIconComponent,
        OverlayModule,
    ],
    providers: [
        provideState({ name: 'modal', reducer: ModalReducer }),
        ConfirmationDialogService,
        DialogService,
    ],
})
export class DialogModule {}
